// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2i9Jb","content":"LayoutSettings_content__3S1JH"};